const { setInitialised } = window.BAO.Carousel.plugins

class CtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.detailsChanged = this.detailsChanged.bind(this)

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'free-snap',
        slides: {
          perView: 'auto',
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 901px)': {
            mode: this.dataset.mode,
            slides: {
              perView: 'auto',
              spacing: 30,
            },
          },
        },
        detailsChanged: this.detailsChanged,
      },
      [setInitialised()],
    )
  }

  detailsChanged () {
    window.BAO.dispatchEvent(window.BAO.EVENTS.CAROUSEL.MOVING)
  }
}

if (!customElements.get('cta-carousel')) {
  customElements.define('cta-carousel', CtaCarousel)
}
